import { ArpFields } from "constants/forecasts.constants";

/**
 * Get tooltip text for header fields in the Type Well Input Table
 */
export function getHeaderTooltip(header: string): string | undefined {
  switch (header) {
    case ArpFields.EUR:
      return "Technical EUR calculated from the start date to the end date of the product";
    case ArpFields.RestrictedEUR:
      return "EUR calculated from the start date to the primary product's end date (cutoff date)";
    case ArpFields.QfAtCutoff:
      return "Flow rate at the primary product's end date (cutoff date)";
    default:
      return undefined;
  }
}
